import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {AuthorizationService} from 'src/app/core/services/authorization.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  constructor(
    private authorizationService: AuthorizationService,
    private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const haveAdminRights = this.authorizationService.isAdmin();
    if (haveAdminRights) {
      return true;
    } else {
      return this.router.createUrlTree(['unauthorized-access']);
    }
  }
}
